import React from 'react'
import EmailTemplateManage from '../../../features/FieldManagement/EmailTempManagement/EmailTemplateManage'

export default function EmailTemplateManagement() {
    return (
        <EmailTemplateManage />
    )
}

